//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'Bank',
};
